import { Browser } from "../../core/browser";
import { ChipsideComponent } from "../chipside-component";

export class BreadcrumbItem extends ChipsideComponent {
	constructor() {
		super();

		this.link = this.getAttribute("link") ?? "";
		this.target = this.getAttribute("target");
		this.icon = this.getAttribute("icon") ?? "";
		this.isCurrent = Browser.ResolveRelativeURL(this.link) === location.toString();

		if (this.isCurrent) {
			this.link = "";
		}
	}

	parsedCallback() {
		if (this.link) {
			const anchor = document.createElementWithContents("a", this.childNodes, { href: Browser.ResolveRelativeURL(this.link) });

			if (this.target) {
				anchor.target = this.target;
			}

			this.appendChild(anchor);
		}

		if (this.icon) { (this.link ? this.querySelector("a") : this).prepend(document.createElementWithContents("i", null, { className: this.icon })); }
	}
}